async function updateRewardBar() {
  const bars = document.querySelectorAll('[data-reward-bar]');
  if (!bars.length) return;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const itemCount = cart.item_count || 0;

    bars.forEach((bar) => {
      const tier1Target = parseInt(bar.dataset.tier1Target || '5', 10);
      const tier1Label = bar.dataset.tier1Label || '20% off';
      const tier2Target = parseInt(bar.dataset.tier2Target || '10', 10);
      const tier2Label = bar.dataset.tier2Label || '30% off';

      const track = bar.querySelector('[data-reward-track]');
      const message = bar.querySelector('[data-reward-message]');
      const tier1Marker = bar.querySelector('[data-tier-1-marker]');
      const tier2Marker = bar.querySelector('[data-tier-2-marker]');

      const progress = Math.min((itemCount / tier2Target) * 100, 100);

      // Progress fill via ::after so end caps use the same pill radius as the track
      // (background-size rectangles leave a mismatched right cap near 100%).
      if (track) {
        const pct = Math.min(Math.max(progress, 0), 100);
        track.style.removeProperty('background');
        track.style.removeProperty('background-color');
        track.style.removeProperty('background-image');
        track.style.removeProperty('background-size');
        track.style.removeProperty('background-repeat');
        track.style.removeProperty('background-position');
        track.style.setProperty('--reward-progress', `${pct}%`);
        track.classList.toggle('is-full', pct >= 100);
      }

      // Keep milestone bubbles aligned with the bar scale.
      if (tier1Marker) {
        tier1Marker.style.left = `${(tier1Target / tier2Target) * 100}%`;
        tier1Marker.classList.toggle('is-active', itemCount >= tier1Target);
      }

      if (tier2Marker) {
        tier2Marker.style.left = '100%';
        tier2Marker.classList.toggle('is-active', itemCount >= tier2Target);
      }

      if (!message) return;

      // Update the tiered progress message.
      if (itemCount >= tier2Target) {
        message.innerHTML = `You unlocked <span class="reward-bar__highlight">${tier2Label}</span>`;
      } else if (itemCount >= tier1Target) {
        message.innerHTML = `You unlocked <span class="reward-bar__highlight">${tier1Label}</span>. Buy <span class="reward-bar__highlight">${tier2Target - itemCount}</span> more to get <span class="reward-bar__highlight">${tier2Label}</span>`;
      } else {
        message.innerHTML = `Buy <span class="reward-bar__highlight">${tier1Target - itemCount}</span> more to get <span class="reward-bar__highlight">${tier1Label}</span>`;
      }
    });
  } catch (error) {
    // Fail silently so the product/cart UI never breaks.
  }
}

function tryBindCartUpdateListener() {
  if (tryBindCartUpdateListener.bound) return;
  if (typeof subscribe !== 'function') return;
  if (typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(updateRewardBar, 50);
  });
  tryBindCartUpdateListener.bound = true;
}
tryBindCartUpdateListener.bound = false;

function initRewardBar() {
  updateRewardBar();
  tryBindCartUpdateListener();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRewardBar);
} else {
  initRewardBar();
}

window.addEventListener('load', () => {
  updateRewardBar();
  tryBindCartUpdateListener();
});

window.addEventListener('pageshow', updateRewardBar);

// Pub/sub loads deferred in <head>; reward-bar.js may run before `subscribe` exists.
setTimeout(initRewardBar, 0);
setTimeout(initRewardBar, 150);
setTimeout(initRewardBar, 500);

// Reward bar needs to react shortly after quantity changes / cart interactions.
document.addEventListener('click', () => {
  setTimeout(updateRewardBar, 300);
  setTimeout(updateRewardBar, 800);
  setTimeout(updateRewardBar, 1500);
});